import { convertHtmlToReact } from "@hedgedoc/html-to-react/dist/convertHtmlToReact";
export const convertTag = (data, value, tag) => {
  if (!data || data?.length <= 0) return;
  return convertHtmlToReact(
    data?.split(tag)[0] + `<strong>${value}</strong>` + data?.split(tag)[1]
  );
};
